const Normal = ({ children }: { children: React.ReactNode }) => {
  return <h1 className="font-outfit text-white text-[14px]">{children}</h1>;
};

export default Normal;
